import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const PersonligEnergianalys = lazy(() => import("@/pages/PersonligEnergianalys"));

export const Route = createFileRoute("/personlig-energianalys")({
  head: () => seoHead("/personlig-energianalys"),
  component: () => <PersonligEnergianalys />,
});
